import AddEditBookingMessage from './AddEditBookingMessage';

export default AddEditBookingMessage;
